var React = require('react');

function ReadmoreInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.3002 4.78942C0.943161 4.8369 0.667969 5.13694 0.667969 5.49999C0.667969 5.89604 0.99547 6.2171 1.39946 6.2171L9.39724 6.2171L9.39724 10.2817C9.39724 10.8462 10.0316 11.1893 10.5187 10.8885L18.2599 6.10672C18.7152 5.82543 18.7152 5.17457 18.2599 4.89328L10.5187 0.111548C10.0316 -0.189341 9.39724 0.153846 9.39724 0.71827L9.39724 4.78287L1.39946 4.78287L1.3002 4.78942ZM10.8588 5.54311C10.8597 5.52884 10.8601 5.51446 10.8601 5.49999C10.8601 5.48551 10.8597 5.47113 10.8588 5.45686L10.8588 2.01893L16.4962 5.50029L10.8588 8.9826L10.8588 5.54311Z","fill":"currentColor"}));
}

ReadmoreInline.defaultProps = {"width":"19","height":"11","viewBox":"0 0 19 11"};

module.exports = ReadmoreInline;

ReadmoreInline.default = ReadmoreInline;
